const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferedS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(15.294118%,81.176471%,29.803922%)",
      fillOpacity: 1
    },
    d: "M 36 18 C 36 27.941406 27.941406 36 18 36 C 8.058594 36 0 27.941406 0 18 C 0 8.058594 8.058594 0 18 0 C 27.941406 0 36 8.058594 36 18 Z M 36 18 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.308594 12.828125 L 13.691406 12.828125 C 13.214844 12.828125 12.828125 13.214844 12.828125 13.691406 L 12.828125 22.308594 C 12.828125 22.785156 13.214844 23.171875 13.691406 23.171875 L 19.546875 23.171875 C 19.773438 23.171875 19.992188 23.082031 20.15625 22.921875 L 22.921875 20.15625 C 23.082031 19.992188 23.171875 19.773438 23.171875 19.546875 L 23.171875 13.691406 C 23.171875 13.214844 22.785156 12.828125 22.308594 12.828125 Z M 16.277344 15.84375 L 19.726562 15.84375 C 19.964844 15.84375 20.160156 16.039062 20.160156 16.277344 C 20.160156 16.515625 19.964844 16.707031 19.726562 16.707031 L 16.277344 16.707031 C 16.039062 16.707031 15.847656 16.515625 15.847656 16.277344 C 15.847656 16.039062 16.039062 15.84375 16.277344 15.84375 Z M 18 20.15625 L 16.277344 20.15625 C 16.039062 20.15625 15.847656 19.960938 15.847656 19.722656 C 15.847656 19.488281 16.039062 19.292969 16.277344 19.292969 L 18 19.292969 C 18.238281 19.292969 18.433594 19.488281 18.433594 19.722656 C 18.433594 19.960938 18.238281 20.15625 18 20.15625 Z M 16.277344 18.429688 C 16.039062 18.429688 15.847656 18.238281 15.847656 18 C 15.847656 17.761719 16.039062 17.570312 16.277344 17.570312 L 19.726562 17.570312 C 19.964844 17.570312 20.160156 17.761719 20.160156 18 C 20.160156 18.238281 19.964844 18.429688 19.726562 18.429688 Z M 19.726562 22.132812 L 19.726562 19.722656 L 22.136719 19.722656 Z M 19.726562 22.132812 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferedS);
export default __webpack_public_path__ + "static/media/offered_s.3ca993e603eadbea5562a37765237f74.svg";
export { ForwardRef as ReactComponent };